import i18n  from '@/lang';

export default [
  {
    path: '/testing/update',
    name: '编辑测试',
    component: () => import(/* webpackChunkName: "UpdateTestPaper" */ '../views/Testing/UpdateTestPaper/UpdateTestPaper.vue')
  },
  {
    path: '/testing/create',
    name: '发布测试',
    meta: {
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "AddTestPaper" */ '../views/Testing/AddTestPaper/AddTestPaper.vue')
  },
  {
    path: '/testing/detail',
    name: '测试详情',
    component: () => import(/* webpackChunkName: "TestingDetail" */ '../views/Testing/TestingDetail/TestingDetail.vue')
  },
  {
    path: '/testing/settings',
    name: '测试设置',
    component: () => import(/* webpackChunkName: "TestingDetail" */ '../views/Testing/Settings.vue')
  },
  {
    path: '/testing/batch',
    name: '批量操作',
    component: () => import(/* webpackChunkName: "Batch" */ '../views/Testing/TestingDetail/cmps/correct/batch.vue')
  },
  {
    path: '/testing/review',
    name: '',
    component: () => import(/* webpackChunkName: "ReviewTestPaper" */ '../views/Testing/ReviewTestPaper/ReviewTestPaper.vue')
  },
  {
    path: '/testing/preview',
    name: '试题预览',
    component: () => import(/* webpackChunkName: "Preview" */ '../views/Testing/Preview/preview.vue')
  },
  {
    path: '/testing/stu/detail',
    name: '测试内容',
    component: () => import(/* webpackChunkName: "TestingStuDetail" */ '../views/Testing/Student/detail.vue')
  },
  {
    path: '/testing/stu/ontesting',
    name: '测试',
    component: () => import(/* webpackChunkName: "TestingTestingpaper" */ '../views/Testing/Student/testpaper.vue')
  },
  {
    path: '/testing/stu/testingresult',
    name: '测试详情',
    component: () => import(/* webpackChunkName: "TestingTestingpaper" */ '../views/Testing/Student/testpaperResult.vue')
  },
  {
    path: '/testing/stu/submitresult',
    name: '测试结果',
    component: () => import(/* webpackChunkName: "SubmitResult" */ '../views/Testing/Student/submitResult.vue')
  },
  {
    path: '/testing/stu/releaseresult',
    name: '测试成绩',
    component: () => import(/* webpackChunkName: "SubmitResult" */ '../views/Testing/Student/testpaperResultSheet.vue')
  },
  {
    path: '/sets/mistakes/list',
    name: i18n.t('CourseHome.错题集') as string,
    component: () => import(/* webpackChunkName: "MistakesSet" */ '../views/MistakesSet/index.vue')
  },
  {
    path: '/sets/mistakes/detail',
    name: '错题详情',
    component: () => import(/* webpackChunkName: "MistakesSet" */ '../views/MistakesSet/detail.vue')
  }
]